






















import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import { NOW_YEAR, thMonthsMini, timeframeSubtract } from '@/utils';

import ChartWithMoneyAxis from '@/components/Vivat/Chart/ChartWithMoneyAxis.vue';

const ChartWithFtlCompare = defineComponent({
  components: {
    ChartWithMoneyAxis,
  },
  props: {
    primaryColor: {
      type: String,
      default: 'rgba(18,74,136,255)',
    },
    secondaryColor: {
      type: String,
      default: 'rgba(80,161,242,255)',
    },
    query: {
      default: undefined,
    },
    result: {
      type: Function,
      default: undefined,
    },
    lastYearResult: {
      type: Function,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
    formatYAxis: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const filter = reactive({
      year: {
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      },
    });

    const { result, loading } = useQuery(
      props.query as any,
      computed(() => ({
        timeframe: filter.year,
        timeframeY1: timeframeSubtract(filter.year),
      })),
      () => ({
        fetchPolicy: 'network-only',
        enabled: props.query !== undefined && props.result !== undefined && props.lastYearResult !== undefined,
      }),
    );
    const rawData = computed(() => {
      if (loading.value === false && result.value && props.result !== undefined && props.lastYearResult !== undefined) {
        return {
          currentYear: props.result(result.value),
          lastYear: props.lastYearResult(result.value),
        };
      }
      return { currentYear: [], lastYear: [] };
    });
    const mapRawDataIntoFormat = computed(() => {
      const primaryCurrentYear = [];
      const primaryLastYear = [];
      let totalCurrentYear = 0;
      let totalLastYear = 0;
      for (let i = 0; i < rawData.value.currentYear.length; i += 1) {
        primaryCurrentYear.push(rawData.value.currentYear[i].fullTruckLoaded);
        totalCurrentYear += (rawData.value.currentYear[i].fullTruckLoaded);
      }
      for (let i = 0; i < rawData.value.currentYear.length; i += 1) {
        primaryLastYear.push(rawData.value.lastYear[i].fullTruckLoaded);
        totalLastYear += (rawData.value.lastYear[i].fullTruckLoaded);
      }
      return {
        primaryCurrentYear,
        primaryLastYear,
        totalCurrentYear,
        totalLastYear,
      };
    });
    const percentage = computed(() => {
      const data = [];
      for (let i = 0; i < mapRawDataIntoFormat.value.primaryCurrentYear.length; i += 1) {
        data.push(((mapRawDataIntoFormat.value.primaryCurrentYear[i])
          / mapRawDataIntoFormat.value.totalCurrentYear) * 100);
      }
      return {
        data: [
          {
            label: 'Percentage',
            data,
            borderColor: 'pink',
            backgroundColor: 'pink',
            type: 'line',
            order: 0,
            yAxisID: 'y1',
          },
        ],
        scales: {
          y1: {
            type: 'linear',
            display: true,
            position: 'right',
            grid: {
              drawOnChartArea: false,
            },
            ticks: {
              // eslint-disable-next-line
              callback: (value: number) => `${value}%`,
            },
          },
        },
      };
    });
    const chartData = computed(() => ({
      labels: thMonthsMini,
      datasets: [
        {
          label: 'FTL (Y-1)',
          data: mapRawDataIntoFormat.value.primaryLastYear,
          backgroundColor: 'rgba(204,205,213,255)',
          stack: 'Y-1',
        },
        {
          label: 'FTL',
          data: mapRawDataIntoFormat.value.primaryCurrentYear,
          backgroundColor: props.primaryColor,
          stack: 'CURRENT',
        },
        ...percentage.value.data,
      ],
    }));

    return {
      filter,
      chartData,
      rawData,
      percentage,
    };
  },
});

export default ChartWithFtlCompare;
